/* eslint-disable no-unused-vars */
import React, { useMemo, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { onSavePoints } from "../../Store/Slices/cardDataSlice";
import { getMinPrice } from "../../Common/HOC/Hoc";
import img from "../../Assets/is.png";
import getTranslationData from "../../TranslationUtility/TranslationUtility";
import { ClientInfo } from "../Utility/Utility";

function SelectCard({ updatedData, productReducer, setEarnPoints, points }) {
  const translation = getTranslationData();
  const dispatch = useDispatch();
  const priceDenomination =
    productReducer?.productReducer?.priceDenominations
      ?.split(",")
      .map(Number);

      const selectedPriceDenomination =
    productReducer?.productReducerDisocount?.priceDenomination
      ?.split(",")
      .map(Number); 
  const discount = productReducer?.productReducerDisocount?.customerDiscount;

  const cardData = JSON.parse(sessionStorage.getItem("accountData"));
  const cardInfo = JSON.parse(sessionStorage.getItem("cardInfo"));
  const Updatedcard = useSelector((state) => state.cardDataSliceReducer);

  const mergedArray = useMemo(
    () =>
      cardData?.map((item1) => {
        const matchingItem = cardInfo?.find(
          (item2) => item2.identifier === item1.subIdentifier
        );
        return {
          ...item1,
          ...(matchingItem ? { cardDetails: matchingItem } : {}),
        };
      }),
    [cardData, cardInfo]
  );

  const creditCards = useMemo(
    () =>
      mergedArray?.filter(
        (card) => card?.cardDetails?.identifiertype === "1002"
      ),
    [mergedArray]
  );

  // Initialize selectedCard with the value from localStorage or default to the first card
  const [selectedCard, setSelectedCard] = useState(
    () =>
      sessionStorage.getItem("selectedCard") ||
      creditCards?.[0]?.cardDetails?.CardTypeName ||
      null
  );

  useEffect(() => {
    if (selectedCard) {
      sessionStorage.setItem("selectedCard", selectedCard);
    }
  }, [selectedCard]);

  // const productDiscount = useSelector(
  //   (state) =>
  //     state?.ClientProductMappingbyIdReducer.data?.[0]?.clientProductMapping
  // );
  // const minEarnPoints = productDiscount?.find(
  //   (entry) => entry.productId === productReducer?.productReducer?.[0]?.id
  // );
  const minEarn = productReducer?.productReducer?.minEarnPoints;

  const validateLoginTokenData = useSelector(
    (state) => state.validateLoginTokenSliceReducer.data
  );
  const handleCardChange = (card) => {
    setSelectedCard(card);
  };

  let totalDenomination = 0;
  let totalQuantity = 0;
  let totalPayableAmount = 0;

  updatedData?.forEach((item) => {
    totalDenomination += item.denomination * item.quantity;
    totalQuantity += item.quantity;
    totalPayableAmount += item.you_pay * item.quantity;
  });

  const capitalizeFirstLetter = (str) => {
    return str
      ?.split(" ")
      ?.map(
        (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
      )
      .join(" ");
  };
  const handlePointsChange = (card) => {
    dispatch(
      onSavePoints({
        points: Math.round(card?.memberBalance?.pointBalance),
        identifierType: card?.identifierType,
        subIdentifier: card?.subIdentifier,
      })
    );
  };

  const earnPoints = () => {
    var earn = Math.round(
      (totalDenomination - (totalDenomination * discount) / 100) *
        (minEarn / getMinPrice(selectedPriceDenomination))
    ).toLocaleString(undefined, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });
    setEarnPoints(earn);
    return earn;
  };
  const clientinfo = ClientInfo();
  const clientConfigurations = clientinfo?.clientData?.clientConfigurations;
  const isEarnView = clientConfigurations?.find((item) => item.configKey.toLowerCase() === "isearnview")?.configValue;
  const isEarn = clientConfigurations?.find((item) => item.configKey.toLowerCase() === "isearn")?.configValue;

  return (
    <div id="selectCardContainer" className="selectCardContainer">
      {(totalDenomination - (totalDenomination * discount) / 100) *
        (minEarn / getMinPrice(priceDenomination)) !==
        0 && (
        (isEarnView || isEarn) ? (isEarnView !== 2 || isEarn !== 2) &&  <div className={`points ${points === 0 && "jcSb"}`}>
          {points === 0 ? (
            <p>{translation?.pointsEarn}</p>
          ) : (
            <>
              <img className="w-144 img mar2" src={img} alt="img" />

              <p>{translation?.pointsEarnedPayment}</p>
            </>
          )}
          {points === 0 ? (
            <span className="points-value d-flex align-item-center">
              {earnPoints()} {translation?.pts}
            </span>
          ) : (
            " "
          )}
        </div>: <>{earnPoints()} {translation?.pts}</>
      )}
      {creditCards?.length > 0 && (
        <div
          className={`card-selection ${
            (totalDenomination - (totalDenomination * discount) / 100) *
              (minEarn / getMinPrice(priceDenomination)) !==
            0
              ? ""
              : "mt-4"
          }`}
        >
          <p className="card-selection-title">{translation?.selectCard}</p>
          {creditCards?.map((card) => (
            <div className="card-option" key={card?.cardDetails?.identifier}>
              <input
                type="radio"
                name="card"
                value={card.cardDetails.CardTypeName}
                className="card-checkout-UI card-checkout_radio"
                checked={selectedCard === card.cardDetails.CardTypeName}
                onChange={() => {
                  handleCardChange(card.cardDetails.CardTypeName);
                  handlePointsChange(card);
                }}
              />
              <label className="card-label card-checkout-UI">
                <span className="card_name">
                  {capitalizeFirstLetter(
                    card?.cardDetails?.CardTypeName.length > 10
                      ? card?.cardDetails?.CardTypeName?.substring(0, 10) +
                          "..."
                      : card?.cardDetails?.CardTypeName
                  )}
                </span>
                <span className="card-number">
                  {card.cardDetails.CardNoLast4Digit}
                </span>
                <span className="points-value points-value_btn ">
                  <i className="fa-solid fa-star fa-star_icon dstp-star"></i>{" "}
                  {Math.round(
                    card?.subIdentifier === Updatedcard?.subIdentifier
                      ? Updatedcard?.points
                      : card.memberBalance?.pointBalance
                  )}
                </span>
              </label>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default SelectCard;
